import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import SegmentedTabs from '../../../reusable/SegmentedTabs/SegmentedTabs';
import { t } from '../../../i18n/i18n';
import './AffiliateMarketing.scss';

const BASE = '/affiliate/marketing';

/**
 * The three tabs of the live dashboard's Affiliate Marketing page
 * (`AffiliatePage.jsx` on main), each its own route so a tab can be linked.
 */
export const TABS = [
  { label: 'Overview', value: BASE },
  { label: 'Affiliate Codes', value: `${BASE}/codes` },
  { label: 'Commission Payouts', value: `${BASE}/payouts` },
];

/**
 * Layout route for `/affiliate/marketing/*` — the tablist above whichever tab
 * is open. The active tab comes from the path, so the back button and a
 * pasted link both land on the right one.
 */
export default function AffiliateMarketing() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = TABS.find((tab) => tab.value !== BASE && pathname.startsWith(tab.value))?.value ?? BASE;

  return (
    <div className="aff-marketing">
      <div className="aff-marketing__tabs">
        <SegmentedTabs
          radius="track"
          options={TABS.map((tab) => ({ ...tab, label: t(tab.label) }))}
          value={active}
          onChange={navigate}
        />
      </div>
      <Outlet />
    </div>
  );
}
